import React from 'react'
import { FaMinus } from 'react-icons/fa';

function Eleventh() {
  return (
    <section className='eleven'>
        <p>Make an impact - join the PayZone team</p>
        <span>
            <FaMinus/> 
            Learn More
        </span>
    </section>
  )
}

export default Eleventh